import isNumber from 'lodash/isNumber'
import numeral from 'numeral'

export const parseNumber = (value: string) => {
  return numeral(value).value()
}

export const formatAbbreviatedNumber = (n: number | undefined | null) => {
  if (!isNumber(n)) return ''
  let formatter
  if (n > 10000000000) formatter = '00a'
  else if (n > 1000000000) formatter = '0.0a'
  else if (n > 10000000) formatter = '0a'
  else if (n > 1000000) formatter = '0.0a'
  else formatter = '0a'
  return numeral(n)
    .format(formatter)
    .toUpperCase()
}

export const parseAbbreviatedNumber = (value: string) => {
  let lowerCaseVal = value.toLowerCase()
  if (lowerCaseVal.includes('k') && !lowerCaseVal.endsWith('k')) {
    lowerCaseVal = lowerCaseVal.replace('k', '') + 'k'
  } else if (lowerCaseVal.includes('m') && !lowerCaseVal.endsWith('m')) {
    lowerCaseVal = lowerCaseVal.replace('m', '') + 'm'
  } else if (lowerCaseVal.includes('b') && !lowerCaseVal.endsWith('b')) {
    lowerCaseVal = lowerCaseVal.replace('b', '') + 'b'
  }
  return numeral(lowerCaseVal).value()
}

export const formatNumberComma = (value: number | string) => {
  return value ? numeral(value).format('0,0') : ''
}

export const formatAbbreviatedMoney = (n: number | undefined | null) => {
  if (!isNumber(n)) return ''
  return `$${formatAbbreviatedNumber(n)}`
}

export const formatSharePrice = (n: number | undefined | null) => {
  if (!n) return ''
  return numeral(n).format('$0,0.00')
}

export const formatNumberToPrecision = (n: number | undefined | null, significantDigits: number) => {
  if (!n) return ''
  return numeral(n.toPrecision(significantDigits))
    .format('0,0[.]0a')
    .toUpperCase()
}

export const formatMoneyToPrecision = (n: number | undefined | null, significantDigits: number) => {
  const value = formatNumberToPrecision(n, significantDigits)
  return value ? `$${value}` : ''
}

export const parsePercent = (value: string) => {
  const parsed = numeral(value).value()
  if (value.includes('%') || parsed < 1.0) return numeral(value).value()

  return numeral(value + '%').value()
}

export const formatPercent = (value: number | null) => {
  return value !== null ? numeral(value).format('0[.][00000]%') : ''
}
